class Filter {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  unmount() {
    this.ui.$input.removeEventListener('keydown', this.onChange.bind(this));
    this.ui.$input.removeEventListener('keyup', this.onChange.bind(this));
    this.ui.$input.removeEventListener('focusin', () => this.ui.$label.style.display = 'none');
    this.ui.$input.removeEventListener('focusout', this.onFocusOut.bind(this));
    window.removeEventListener('select:created', this.onSelectDone.bind(this));

    this.data = [];
    this.ui = {};
  }

  bindUI() {
    this.data = [];
    this.ui = {};
    this.ui.$input = this.element.querySelector('[data-ref="filter-input"]');
    this.ui.$label = this.element.querySelector('[data-ref="filter-label"]');
    this.ui.$location = this.element.querySelectorAll('[filter-location]');
    this.ui.$list = null;
  }

  bindEvents() {
    this.ui.$input.addEventListener('keydown', this.onChange.bind(this));
    this.ui.$input.addEventListener('keyup', this.onChange.bind(this));
    this.ui.$input.addEventListener('focusin', () => this.ui.$label.style.display = 'none');
    this.ui.$input.addEventListener('focusout', this.onFocusOut.bind(this));
    this.ui.$location.forEach((item) => {
      item.addEventListener('click', this.onClick.bind(this));
    });
    // wait for custom select to be created and then get all options
    window.addEventListener('select:created', this.onSelectDone.bind(this));
    document.addEventListener('click', (e) => {
      if (!e.target.classList.contains('customS__list') && this.ui.$input.value != '') {
        this.ui.$input.value = '';
      } else {
        this.ui.$list.forEach((item) => {
          item.removeAttribute('style');
        });
      }
    });
  }

  onClick(event) {
    this.ui.$list.forEach((item) => {
      if (event.target.getAttribute('filter-location') == 'All') {
        item.removeAttribute('style');
      } else if (item.getAttribute('data-location') == event.target.getAttribute('filter-location')) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
  }

  onSelectDone() {
    this.ui.$list = this.element.querySelectorAll('.customS__option');

    this.ui.$list.forEach((item) => {
      this.data.push({
        name: item.getAttribute('data-value'),
        index: item.getAttribute('data-index'),
      });
    });
  }

  onChange(e) {
    const keyword = e.target.value;

    if (keyword !== '') {
      const results = this.data.filter((user) => {
        return user.name.toLowerCase().includes(keyword.toLowerCase());
      });

      this.ui.$list.forEach((item) => {
        item.style.display = 'none';
      });
      results.forEach((result) => {
        this.ui.$list[result.index].style.display = 'block';
      });
    } else {
      this.ui.$list.forEach((item) => {
        item.style.display = 'block';
      });
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.ui.$input.value == '') {
        this.ui.$list.forEach((item) => {
          item.removeAttribute('style');
        });
      }
    }, 300);
  }
}

export default Filter;
